// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/item_sales_velocity_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MovingItemsItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ItemSalesVelocityReportRequest
 */
export class ItemSalesVelocityReportRequest extends Message<ItemSalesVelocityReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ItemSalesVelocityReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemSalesVelocityReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemSalesVelocityReportRequest {
    return new ItemSalesVelocityReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemSalesVelocityReportRequest {
    return new ItemSalesVelocityReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemSalesVelocityReportRequest {
    return new ItemSalesVelocityReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ItemSalesVelocityReportRequest | PlainMessage<ItemSalesVelocityReportRequest> | undefined, b: ItemSalesVelocityReportRequest | PlainMessage<ItemSalesVelocityReportRequest> | undefined): boolean {
    return proto3.util.equals(ItemSalesVelocityReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ItemSalesVelocityReportResponse
 */
export class ItemSalesVelocityReportResponse extends Message<ItemSalesVelocityReportResponse> {
  /**
   * List of item sales velocity items
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItemsItem item_sales_velocity_items = 1;
   */
  itemSalesVelocityItems: MovingItemsItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ItemSalesVelocityReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemSalesVelocityReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_sales_velocity_items", kind: "message", T: MovingItemsItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemSalesVelocityReportResponse {
    return new ItemSalesVelocityReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemSalesVelocityReportResponse {
    return new ItemSalesVelocityReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemSalesVelocityReportResponse {
    return new ItemSalesVelocityReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ItemSalesVelocityReportResponse | PlainMessage<ItemSalesVelocityReportResponse> | undefined, b: ItemSalesVelocityReportResponse | PlainMessage<ItemSalesVelocityReportResponse> | undefined): boolean {
    return proto3.util.equals(ItemSalesVelocityReportResponse, a, b);
  }
}

